import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  gap: ${({ theme }) => theme.spacing['2Xl']};
`;

export const TextContainer = styled.div`
  text-align: center;
`;

export const Tiles = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.md};
`;

export const CustomerResponse = styled.div`
  width: ${({ theme }) => theme.spacing['2Xl']};
  height: ${({ theme }) => theme.spacing['2Xl']};
  font-size: ${({ theme }) => theme.spacing['2Xl']};
`;
